import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  loadingContainer: height => ({
    height,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 16,
  }),
  loadingIcon: {
    height: 125,
  },
  loadingMessage: theme => ({
    fontSize: 17,
    marginTop: 35,
    color: theme.colors.loadingTextColor,
  }),
});
